import { vservice } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vservice()
export class WriterWalletRoute extends RouteBase {
  prefix = 'writer.wallet.'

  wallet(userId: number) {
    return this.ziggyRoute('wallet-index')
  }
}
